var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaHead1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21V17.6667C17 16.5848 17.3509 15.5321 18 14.6667L19 13.3333C19.6491 12.4679 20 11.4152 20 10.3333V9.5C20 5.35786 16.6421 2 12.5 2C8.35786 2 5 5.35786 5 9.5V9.68C5 9.88772 4.93263 10.0898 4.808 10.256L2.3 13.6C2.10527 13.8596 2 14.1754 2 14.5C2 15.3284 2.67157 16 3.5 16H5V18.457C5 19.3092 5.69082 20 6.54299 20C7.50116 20 8.44617 19.7769 9.30319 19.3484L10 19V21C10 21.5523 10.4477 22 11 22H16C16.5523 22 17 21.5523 17 21ZM14 12.264C14 12.5805 13.7485 12.837 13.4382 12.837H11.5618C11.2515 12.837 11 12.5805 11 12.264C11 11.8153 10.7327 11.4209 10.3779 11.1555C9.54038 10.529 9 9.54066 9 8.42867C9 6.53507 10.567 5 12.5 5C14.433 5 16 6.53507 16 8.42867C16 9.54066 15.4596 10.529 14.6221 11.1555C14.2673 11.4209 14 11.8153 14 12.264ZM10.8877 14.3756C10.8877 14.0307 11.1618 13.7511 11.5 13.7511H13.5C13.8382 13.7511 14.1123 14.0307 14.1123 14.3756C14.1123 14.7204 13.8382 15 13.5 15H11.5C11.1618 15 10.8877 14.7204 10.8877 14.3756Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaHead1);
export default __webpack_public_path__ + "static/media/idea-head-1.cdef93d845ca49088677d0799be50d26.svg";
export { ForwardRef as ReactComponent };